module.exports = __webpack_public_path__ + "static/media/dark-side-cookies.380ce78c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/modern-javascript/assets/dark-side-cookies.jpg
// module id = 1531
// module chunks = 0